module.exports = __webpack_public_path__ + "img/Tokyo-Banner_1.70bc1723.png";